/*import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import rootReducer from "./reducers";

const middleware = [thunk];

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
*/

// store.js - Configuration du store Redux
import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";

// Importez vos reducers existants
import dashboardReducer from "./reducers/dashboard";
import alertReducer from "./actions/alertReducer";
// Importez d'autres reducers si nécessaire

const rootReducer = combineReducers({
  alert: alertReducer,
  dashboard: dashboardReducer,
  // Ajoutez d'autres reducers ici
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
